<script>
export default {
    name: "Procurements"
}
</script>

<template>
    <div class="mt-3">
        <div class="d-flex mb-3 requests-top" style="column-gap: 10px">
            <div class="flex-fill">
                <form class="search-form">
                    <div class="input-group">
                        <input type="search" class="form-control form-control-lg" placeholder="Search here..." autofocus>
                        <div class="input-group-append">
                            <button class="btn btn-outline-secondary" type="submit">Search</button>
                        </div>
                    </div>
                </form>
            </div>
            <div class="requests-top-buttons">
                <router-link to="/procurements/create" class="btn btn-dark">Procure</router-link>&nbsp;
            </div>
        </div>

        <router-link to="/procurements/view/1" style="color:inherit;" v-for="i in 3" :key="i"
           class="d-flex align-content-center align-items-center p-3 bg-white mb-3 rounded-sm">
            <div class="request-profile p-2 text-center">
                <img src="https://erp.test/storage/avatars/22.jpeg" class="rounded-circle mb-2 d-block" style="height: 120px">
            </div>
                <div class="px-4 flex-fill">
                <h4 class="font-weight-bold">John Doe</h4>
                <div>
                    <div class="text-muted mb-1">Gwen Safaris</div>
                    <p>Our procurement process begins with thorough market research to identify potential suppliers who can meet our requirements. We then issue a Request for Proposal (RFP) outlining our specifications and expectations</p>

                    <div class="d-flex mb-3 text-muted">
                        <div class="mr-2">
                            <span class="status active">processed</span>
                        </div>

                        <ion-icon name="timer-outline" class="icon"></ion-icon>&nbsp;
                        <div class="mr-4">
                            Created: Feb 8, 2024
                        </div>
                        <div class="mr-4">
                            Expected: March 1 2024
                        </div>

                    </div>

                    <div class="small">
                        <button class="btn btn-link text-dark">Edit</button>
                        <button class="btn btn-link text-danger">Delete</button>
                    </div>
                </div>
            </div>
            <div class="p-4">
                <span class="text-muted">USD</span><br>
                <h2 class="font">90.00</h2>
            </div>
        </router-link>
    </div>
</template>

<style scoped>
.icon {
    font-size: 18px;
    vertical-align: middle;
    color: gray
}
</style>